export default {
  THREAD_OPEN: 0,
  THREAD_CLOSED: 1,
}
